import { Link, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import moment from "moment";
import Modal from 'react-bootstrap/Modal';
export default function Clients() {
    const params = useParams();
    const [lists, setLists] = useState([]);
    const [allData, setAllData] = useState([]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);
    const [data, setData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [clientUserId, setClientUserId] = useState("00000000-0000-0000-0000-000000000000");
    const [clientName, setClientName] = useState("");
    const [credits, setCredits] = useState(0);
    const [addShow, setAddShow] = useState(false);
    const handleAddClose = () => {
        setAddShow(false);
    };
    const onCredits = (e, Data) => {
        e.preventDefault();
        setAddShow(true);
        setClientUserId(Data.userId);
        setClientName(Data.clientName);
    };
    const applyErrorClass = (field) => field in errors && errors[field] === false ? " form-control-danger" : "";
    const validate = () => {
        let temp = {};
        temp.credits = credits === 0 ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            setLoading(true);
            axios.post(config.APIACTIVATEURL + config.BONUSCLIENTCREDITS + "?userId=" + clientUserId + "&Credits=" + credits, { ...headerconfig })
                .then((response) => {
                    handleSuccess(response.data.message);
                    resetForm();
                });
        }
    };
    const handleCancel = (e, clientId) => {
        if (window.confirm('Are you sure to cancel the subscription?')) {
            axios.post(config.APIACTIVATEURL + config.CANCELCLIENTRENEWAL + "?ClientId=" + clientId, { ...headerconfig })
                .then((response) => {
                    if (response.data.statusCode === 200) {
                        handleSuccess(response.data.message);
                        GetData(pageNumber);
                    }
                    else {
                        handleError("Error in cancellation");
                        GetData(pageNumber);
                    }
                });
        }
    }
    const handleChange = (e, clientId) => {
        if (window.confirm('Are you sure to change the subscription?')) {
            axios.post(config.APIACTIVATEURL + config.CANCELCLIENTRENEWAL + "?ClientId=" + clientId, { ...headerconfig })
                .then((response) => {
                    if (response.data.statusCode === 200) {
                        handleSuccess(response.data.message);
                        GetData(pageNumber);
                    }
                    else {
                        handleError("Error in cancellation");
                        GetData(pageNumber);
                    }
                });
        }
    }
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json"
        }
    };
    const resetForm = () => {
        setClientName("");
        setClientUserId("00000000-0000-0000-0000-000000000000");
        GetData(1);
        setAddShow(false);
        setCredits(0);
        setLoading(false);
    };
    const handleSearch = (e) => {
        const { name, value } = e.target;
        setClientName(value);
        if (value.length > 2) {
            axios
                .get(config.APIACTIVATEURL + config.SEARCHCLIENT + "?keyword=" + value, { ...headerconfig })
                .then((response) => {
                    setAllData(response.data.data);
                });
        } else if (value.length === 0) {
            GetData(pageNumber);
            setAllData([]);
        }
        else {
            setAllData([]);
        }

    }
    const GetListById = (clientId) => {
        axios
            .get(config.APIACTIVATEURL + config.CLIENTDETAILS + "/" + clientId, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode == 200) {
                    setLists(response.data.data);
                }
                else {
                    setLists([]);
                }
            });
    }
    const handleSelect = (lenderdata) => {
        GetListById(lenderdata.clientId);
        setClientName(lenderdata.clientName);
        setClientUserId(lenderdata.userId);
        setAllData([]);
    }
    const GetLastPageData = () => {
        GetData(totalPages);
    };

    const GetFirstPageData = () => {
        GetData("1");
    };

    const GetPageData = (number) => {
        setPageNumber(number);
        if (pageNumber !== number) GetData(number);
    };

    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }

    const renderPageNumbers = pageNumbers.map((number) => {
        return (
            <li className="page-item" key={number} id={number} onClick={() => GetPageData(number)}>
                <Link className="page-link">{number}</Link>
            </li>
        );
    });

    const onDelete = (e, id) => {
        if (window.confirm('Are you sure to delete this record?')) {
            axios.delete(config.APIACTIVATEURL + config.DELETECLIENT + "/" + id, { ...headerconfig })
                .then((response) => {
                    if (response.data.statusCode === 200) {
                        handleSuccess(response.data.message);
                        GetData(pageNumber);
                    } else {
                        handleError(response.data.message);
                        GetData(pageNumber);
                    }
                });
        }
    };

    const GetData = (number) => {
        axios.get(
            config.APIACTIVATEURL + config.GETCLIENT + "?pageNumber=" + number +
            "&pageSize=" + pageSize,
            { ...headerconfig }
        ).then((response) => {
            if (response.status === 200) {
                setLists(response.data.data.data);
                setPageNumber(response.data.data.pageNumber);
                setPageSize(response.data.data.pageSize);
                setTotalPages(response.data.data.totalPages);
                setData(response.data.data);
                setTotalRecords(response.data.data.totalRecords);
            }
        });
    };
    const getStatus = (endDateUtc) => {
        const now = new Date(); // Local time
        const subscriptionEndDate = new Date(endDateUtc); // UTC date parsed

        // Compare only date part (ignore time)
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const endDate = new Date(
            subscriptionEndDate.getFullYear(),
            subscriptionEndDate.getMonth(),
            subscriptionEndDate.getDate()
        );

        return endDate < today ? false : true;
    };
    useEffect(() => {
        GetData(pageNumber);
    }, []);

    return (
        <div id="layout-wrapper">
            <LayoutHeader></LayoutHeader>
            <LayoutSideBar></LayoutSideBar>
            <div className="body-wrapper">
                <div className="container-fluid">
                    <div className="card w-100 position-relative">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="px-4 py-3 border-bottom">
                                    <h4 className="mb-2 card-title">Clients</h4>
                                </div>
                                <div className="card-body p-3">
                                    <div className="row g-4 align-items-center">
                                        <div className="col-sm-10">
                                            <div className="search-box">
                                                <input type="text" autoComplete="off" className="form-control search" placeholder="Search clients..." name="clientName" onChange={handleSearch} value={clientName} />
                                                <i className="ri-search-line search-icon" />
                                                <ul className="locationListVideo scrollable-list" style={{ minWidth: "350px" }}>
                                                    {allData.length > 0 && allData.map(m =>
                                                        <li className="locationListVideoItem" onClick={() => handleSelect(m)}>{m.clientName}</li>
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body p-3">
                                    <div className="table-responsive table-card">
                                        <table className="table align-middle" id="customerTable">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>Id</th>
                                                    <th>Client</th>
                                                    <th>Credits</th>
                                                    <th>Subscription</th>
                                                    <th>Status</th>
                                                    <th className="text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody className="list form-check-all">
                                                {lists.length > 0 && lists.map((v, index) =>
                                                    <tr key={v.lenderId}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            <p>Name : {v.clientName}</p>
                                                            <p>Email : {v.email}</p>
                                                            <p>Phone : {v.phoneNumber}</p>
                                                        </td>
                                                        <td>Credits : {v.availableCredits}</td>
                                                        <td>
                                                            <p>Name : {v.subscriptionName}</p>
                                                            <p>Renewal Date: {moment(v.endDate).format("DD MMM YYYY")}</p>
                                                            <p>Joined On: {moment(v.createdDate).format("DD MMM YYYY")}</p>
                                                        </td>
                                                        <td>
                                                            <p>Client : {v.isActive === true ? (
                                                                <span className="badge text-bg-primary fs-1">ACTIVE</span>
                                                            ) : (
                                                                <span className="badge text-bg-secondary fs-1">INACTIVE</span>
                                                            )}
                                                            </p>
                                                            <p>Subscription : {v.subscriptionStatus === true ? (
                                                                <span className="badge text-bg-primary fs-1">ACTIVE</span>
                                                            ) : (
                                                                <span className="badge text-bg-secondary fs-1">INACTIVE</span>
                                                            )}
                                                            </p>
                                                            <p>Renewal Status : {v.renewalStatus === true ? (
                                                                <span className="badge text-bg-primary fs-1">ACTIVE</span>
                                                            ) : (
                                                                <span className="badge text-bg-secondary fs-1">INACTIVE</span>
                                                            )}
                                                            </p>
                                                        </td>
                                                        <td>
                                                            {v.renewalStatus === true ?
                                                                <div className="list-inline">
                                                                    <p><Link className="btn btn-primary btn-sm" onClick={e => onCredits(e, v)}>ADD CREDITS</Link></p>
                                                                    <p><Link className="btn btn-secondary btn-sm" to={"/subscription/change/" + v.clientId}>CHANGE PLAN</Link></p>
                                                                    <p><Link className="btn btn-danger btn-sm" onClick={e => handleCancel(e, v.clientId)}>CANCEL PLAN</Link></p>
                                                                </div> :
                                                                <ul className="list-inline hstack gap-2 mb-0">
                                                                    <li className="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Delete">
                                                                        <Link className="btn btn-danger btn-sm">CANCELLED</Link>
                                                                    </li>
                                                                </ul>}
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                                        <div className="flex-shrink-0">
                                            <div className="text-muted">
                                                Showing <span className="fw-semibold">{lists.length}</span> of <span className="fw-semibold">{totalRecords}</span> Results
                                            </div>
                                        </div>
                                        <ul className="pagination pagination-separated pagination-sm mb-0">
                                            <li className={"page-item" + (data.previousPage === null ? 'disabled' : '')} onClick={() => GetFirstPageData()}>
                                                <Link className="page-link">Previous</Link>
                                            </li>
                                            {renderPageNumbers}
                                            <li className={"page-item" + (data.nextPage === null ? 'disabled' : '')} onClick={() => GetLastPageData()}>
                                                <Link className="page-link">Next</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal show={addShow} onHide={handleAddClose}>
                    <Modal.Header>
                        <Modal.Title>Add Bonus Credits</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                            <div className="row">
                                <div className="col-lg-12 mb-3">
                                    <label htmlFor="companyName" className="form-label">Client Name : {clientName}</label>
                                </div>
                                <div className="col-lg-12 mb-3">
                                    <label htmlFor="credits" className="form-label">Credits</label>
                                    <input type="text" value={credits} name="credits" onChange={(e) => setCredits(e.target.value)} className={"form-control" + applyErrorClass('credits')} placeholder="0" />
                                    {errors.credits === false ? (<div className="validationerror">Please add credits </div>) : ('')}
                                </div>
                                <Modal.Footer>
                                    <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                                        {
                                            loading === false ?
                                                <button type="submit" className="btn btn-primary">Add Credits</button>
                                                :
                                                <button type="submit" className="btn btn-primary" disabled>Please wait...</button>
                                        }
                                        <button type="button" className="btn btn-danger" onClick={handleAddClose}>Close</button>
                                    </div>
                                </Modal.Footer>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    );
}